<template>
  <div class="products-page">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">کاتالوگ فروش</p>
        <h1 class="mb-0">سطل زباله محصولات</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="paginationMeta && paginationMeta.total != null">
          <strong>{{ formatNumber(paginationMeta.total) }}</strong>
          <span>محصول</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="trash"></b-icon>
        </div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link :to="{ name: 'ProductsDashboard' }">
          <button type="button" class="btn">بازگشت به صفحه محصولات</button>
        </router-link>
      </div>
    </div>

    <div class="products-list-panel">
      <div class="products-table-wrap">
        <tabel-items :items="TrashProducts" :restoreState="true"/>
      </div>
      <div class="products-pager">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import tabelItems from "../product/tableItems.vue";
import {mapGetters} from "vuex";
import Pagination from "../Pagination.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "../product/products-ui.css";

export default {
  name: "trashItems",
  components: {tabelItems, Pagination},
  methods: {
    formatNumber,
    changePage(page) {
      this.$store.dispatch("Product/getTrash", page);
    },
  },
  computed: {
    ...mapGetters({
      'TrashProducts': "Product/getTrash",
      paginationMeta: "Product/getPaginationMeta",
    }),
  },
  mounted() {
    this.$store.dispatch("Product/getTrash")
  }
};
</script>

<style scoped>
.products-page {
  padding: 8px 4px 24px;
}

.products-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
  border-radius: 22px;
  padding: 24px 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  opacity: 0.8;
  font-size: 13px;
}

.products-hero h1 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 0;
}

.hero-side {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.hero-count {
  text-align: left;
}

.hero-count strong {
  display: block;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.hero-count span {
  font-size: 12px;
  opacity: 0.8;
}

.hero-badge {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
</style>
